export default {
  namespaced: true,
  state: {
    
    reward: {
      type: '', // skip , join 
      user: {}, // if join can save user details 
    },

    ordertype: {
      tip: 0.00,
      pickupTime: '',
      order_receive_method: 'pickup',
      delivery: {},
      delivery_fee: 0.00,
      grandTotal: 0.00,
      user: {},
      note: '',
    },

    payment: {
      pay_later: true,
      token: '',
    },

  },
  getters: {
    reward: state => state.reward,
    ordertype: state => state.ordertype,
    payment: state => state.payment,
    delivery_fee: state =>state.ordertype.delivery_fee,
  },
  mutations: {
    rewardMutate(state, data) {
      state.reward = data;
    },

    orderTypeMutate(state, data) {
      state.ordertype = data;
    },

    paymentMutate(state, data) {
      state.payment = data;
    },

    ordertypeValueByKeysMutate(state, data) {
      for(let key in data){
        if(state.ordertype.hasOwnProperty(key)){
          state.ordertype[key] = data[key];
        }
      }
    },

    resetCheckoutMutate(state) {
      state.reward = {
        type: '',
        user: {},
      };
  
      state.ordertype = {
        tip: 0.00,
        pickupTime: '',
        order_receive_method: 'pickup',
        delivery: {},
        delivery_fee: 0.00,
        grandTotal: 0.00,
        user: {},
        note: '',
      }
  
      state.payment = {
        pay_later: true,
        token: '',
      }
    },

  },
  actions: {
    setReward(context, data) {
      context.commit('rewardMutate', data);
    },

    setOrderType(context, data) {
      context.commit('orderTypeMutate', data);
    },

    setPayment(context, data) {
      context.commit('paymentMutate', data);
    },
    
    setOrderTypeValueByKeys(context, data) {
      context.commit('ordertypeValueByKeysMutate', data);
    },

    resetCheckoutData(context) {
      context.commit('resetCheckoutMutate');
    },

  },
};
